import type { SVGProps } from 'react';
const SvgRoad = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.906 18.934a.9.9 0 0 0-.031.245c0 .495.39.896.871.896h6.317v-1.607c0-.534.417-.964.937-.964s.938.43.938.964v1.607h6.316c.48 0 .871-.401.871-.895 0-.08-.012-.165-.031-.246l-3.446-12.54a.634.634 0 0 0-.601-.465h-3.11v1.607A.95.95 0 0 1 13 8.5a.95.95 0 0 1-.937-.964V5.929h-3.11a.63.63 0 0 0-.601.466L4.906 18.93zm-1.804-.526L6.547 5.872C6.852 4.763 7.836 4 8.953 4h8.094c1.117 0 2.101.763 2.406 1.872l3.445 12.536q.104.375.102.767C23 20.735 21.77 22 20.254 22H5.746C4.23 22 3 20.734 3 19.175q0-.392.102-.767m10.836-7.015v3.214a.95.95 0 0 1-.938.964.95.95 0 0 1-.937-.964v-3.214c0-.535.417-.964.937-.964s.938.43.938.964"
    />
  </svg>
);
export default SvgRoad;
